import React from 'react';
import { deleteAllCookies } from 'smart-react';
import { getTokensFromStorage } from '../../../Utils/Auth/AuthToken';
import { USER_DATA } from '../../../constants/applicationConstants';
import { getConfigurationSetting } from '../../Settings/Services/SettingService';
export const AuthContext = React.createContext();

/**
 * Return Auth Context Object
 * @returns
 */
export const useAuth = () => React.useContext(AuthContext);

/**
 * AuthContext Provider to handle User Data
 * @param {*} param0
 * @returns
 */
export const AuthProvider = ({ children }) => {
  const [user, setUser] = React.useState(null);
  const [userAuthObj, setUserAuthObj] = React.useState(null);
  const [configData, setConfigData] = React.useState(null);

  /**
   * Set User Data
   * @param {*} userdt
   */
  const updateUser = (userdt) => {
    setUser({
      ...userdt,
      full_name: `${userdt.first_name} ${userdt.last_name}`,
    });
  };

  // check for access token in session storage
  // if token is not expired, return true
  const checkTokens = () => {
    const { accessToken } = getTokensFromStorage();
    if (accessToken) {
      // check token for expiration
      const expired = Date.now() > accessToken.tokenExp * 1000;
      if (!expired) {
        return true;
      }
      return false;
    }
    return false;
  };

  // clear session storage upon logout
  const logout = () => {
    sessionStorage.clear();
    deleteAllCookies();
    window.location.replace('/login');
  };

  /**
   * Description: function for fetch configuration from api
   * @return
   */
  const fetchConfiguration = async () => {
    try {
      const response = await getConfigurationSetting();
      setConfigData(response?.config_data);
    } catch (error) {
      console.error('Error getting configuration setting:', error);
    }
  };
  React.useEffect(() => {
    if (!configData && checkTokens()) {
      fetchConfiguration();
    }
  }, []);

  React.useEffect(() => {
    const { accessToken } = getTokensFromStorage();
    if (!user && accessToken) {
      const userDetail = sessionStorage.getItem(USER_DATA);
      updateUser(JSON.parse(userDetail));
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        logout,
        checkTokens,
        user,
        userAuthObj,
        updateUser,
        getTokensFromStorage,
        configData,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
